import React, { useState } from 'react';
import { Box, IconButton, styled, Typography } from '@mui/material';
import KolulaBoxDoor from './KolulaBoxDoor';
import KolulaBoxSquare from './../KolulaBoxSquare';
import KolulaBoxRectangle from './../KolulaBoxRectangle';
import KoluluBoxInfoBox from './../KolulaBoxInfoBox';
import { OrderId } from '../../../../types/order';
import { InfoOutlined } from '@mui/icons-material';

interface KolulaBoxProps {
    orderId?: OrderId;
    activeDoors: number[];
    title: string;
}


const RootBox = styled(Box)(({ theme }) => ({
    backgroundColor: 'black',
    width: '248px',
    height: '260px',
    margin: '0 auto',
    // boxSizing: 'border-box',
    position: 'relative',
    borderRadius: '8px', // Add border-radius for rounded corners
    border: '1px solid black', // Add a solid border
    overflow: 'hidden', // Add overflow to handle scrollbars or content overflow
    transform: 'scale(135%) translateY(45px)',
}));

const DoorWrapper = styled(Box)({
    height: '100%',
    width: '100%',
    top: 0,
    left: 0,
    position: 'relative',
});

const RectangleBox = styled(Box)(({ theme }) => ({
    width: '248px',
    height: '40px',
    position: 'absolute',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
}));

const InfoButton = styled(IconButton)(({ theme }) => ({
    color: theme.palette.primary.dark,
    width: '30px',
    height: '30px',
    position: 'absolute',
    right: 5,
    // top: 0,
}));

const TitleTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.dark,
    fontSize: '13px',
    fontWeight: 'bold',
    marginLeft: '10px',
    // Reserve room for the absolutely-positioned info icon and let long
    // station names wrap instead of sliding under it (#1035 item 2).
    paddingRight: '40px',
    lineHeight: 1.15,
    overflowWrap: 'anywhere',
}));

const ShadowOverlay = styled(Box)(({ theme }) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9,
}));

const KolulaBox = (props: KolulaBoxProps) => {
    const [infoOpen, setInfoOpen] = useState<boolean>(false);

    const enableInfo = Boolean(props.orderId);

    return (
        <>
            <RootBox>
                <DoorWrapper style={{ display: 'flex', flexDirection: 'column' }}>
                    <RectangleBox>
                        <TitleTypography>{props.title}</TitleTypography>
                        {enableInfo && (
                            <InfoButton onClick={() => setInfoOpen(true)}>
                                <InfoOutlined fontSize='small' />
                            </InfoButton>
                        )}
                    </RectangleBox>
                    <Box sx={{ mt: 5.1, position: 'relative' }}>
                        <KolulaBoxSquare posX={0} posY={0} />
                        <KolulaBoxSquare posX={0} posY={186} />
                        <KolulaBoxRectangle posX={93} posY={0} />
                        <KolulaBoxDoor
                            top={0}
                            left={0}
                            orientation={'left'}
                            doorNumber={9}
                            active={props.activeDoors.includes(9)}
                        />
                        <KolulaBoxDoor
                            top={62}
                            left={0}
                            orientation={'right'}
                            doorNumber={5}
                            active={props.activeDoors.includes(5)}
                        />
                        <KolulaBoxDoor
                            top={124}
                            left={0}
                            orientation={'left'}
                            doorNumber={1}
                            active={props.activeDoors.includes(1)}
                        />
                        <KolulaBoxDoor
                            top={0}
                            left={62}
                            orientation={'right'}
                            doorNumber={10}
                            active={props.activeDoors.includes(10)}
                        />
                        <KolulaBoxDoor
                            top={62}
                            left={62}
                            orientation={'left'}
                            doorNumber={6}
                            active={props.activeDoors.includes(6)}
                        />
                        <KolulaBoxDoor
                            top={124}
                            left={62}
                            orientation={'right'}
                            doorNumber={2}
                            active={props.activeDoors.includes(2)}
                        />
                        <KolulaBoxDoor
                            top={0}
                            left={124}
                            orientation={'left'}
                            doorNumber={11}
                            active={props.activeDoors.includes(11)}
                        />
                        <KolulaBoxDoor
                            top={62}
                            left={124}
                            orientation={'right'}
                            doorNumber={7}
                            active={props.activeDoors.includes(7)}
                        />
                        <KolulaBoxDoor
                            top={124}
                            left={124}
                            orientation={'left'}
                            doorNumber={3}
                            active={props.activeDoors.includes(3)}
                        />
                        <KolulaBoxDoor
                            top={0}
                            left={186}
                            orientation={'right'}
                            doorNumber={12}
                            active={props.activeDoors.includes(12)}
                        />
                        <KolulaBoxDoor
                            top={62}
                            left={186}
                            orientation={'left'}
                            doorNumber={8}
                            active={props.activeDoors.includes(8)}
                        />
                        <KolulaBoxDoor
                            top={124}
                            left={186}
                            orientation={'right'}
                            doorNumber={4}
                            active={props.activeDoors.includes(4)}
                        />
                        <KolulaBoxRectangle posX={93} posY={186} />
                        <KolulaBoxSquare posX={217} posY={0} />
                        <KolulaBoxSquare posX={217} posY={186} />
                    </Box>
                </DoorWrapper>
            </RootBox>
            {infoOpen &&
                <ShadowOverlay onClick={() => setInfoOpen(false)}>
                    <KoluluBoxInfoBox onClose={() => setInfoOpen(false)} orderId={props.orderId!}/>
                </ShadowOverlay>
            }
        </>
    );
};

export default KolulaBox;
